export class Anagrafica {
  id: number;
  cognome: string;
  nome: string;
  _titoloScheda: string;
}
